<template>
  <div>
    <main class="site-content">
      <section class="hero is-danger">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Art
            </h1>
            <h2 class="subtitle" style="margin-top: 0.5vh;">
              Some cool art of my character
            </h2>
            <!-- Internet Explorer User may encounter some problems -->
            <div v-if="isIE" class="notification is-danger">
              <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container has-text-centered">
          <vue-picture-swipe :items="items" :options="options"></vue-picture-swipe>
        </div>
      </section>
    </main>
    <div class="content has-text-centered">
      <p>Due to the corona pandemic this site is not updated regulary, if I find my time, I will add new artworks.
      <p>
        <strong>Vue-picture-swipe</strong> by <a href="https://github.com/rap2hpoutre/vue-picture-swipe">Raphaël Huchet</a>. The source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.<br />
        This widget uses the <a href="https://fonts.googleapis.com/icon?family=Material+Icons">Google Fonts API</a> for the <a href="https://material.io/tools/icons/">Material Icons</a>.
      </p>
      <div class="container">
        <strong>All</strong> pictures are <strong>copy protected</strong>.<br />
        <strong>Unauthorized use</strong> and <strong>distribution</strong> is <strong>strictly prohibited!</strong><br>
        <br />

        "Icy" belongs to <strong>IceTiger</strong>.<br />
        "Digo" belongs to <strong>Digo The Husky</strong>.<br />
        "Styx", "Sköll" and "Nara" belong to <strong>Sköll</strong>.<br />
        "Stani" belongs to <strong>Stani</strong>.<br />

        <br />
      </div>
    </div>
    <vue-headful title="Art | IceTiger" description="Some art of the character IceTiger" keywords="art, icetiger, fursona" url="https://icetiger.eu/art"></vue-headful>
  </div>
</template>
<script>
import VuePictureSwipe from 'vue-picture-swipe'

export default {
  name: 'Art',
  data: function() {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent),
      items: [{
        src: '/assets/char/001.jpg',
        thumbnail: '/assets/char/thumb/001.png',
        title: 'Refsheet made by <a href="https://twitter.com/DarkWhiteComic" alt="Refsheet made by DarkWhiteComic">@DarkWhiteComic</a>',
        w: 1920,
        h: 1080
      },
      {
        src: '/assets/char/002.png',
        thumbnail: '/assets/char/thumb/002.png',
        title: 'Icon made by <a href="https://twitter.com/BlueHunterART" alt="Icon made by BlueHunter">@BlueHunterART</a>',
        w: 500,
        h: 500
      },
      {
        src: '/assets/char/003.jpg',
        thumbnail: '/assets/char/thumb/003.png',
        title: 'Icon made by <a href="https://twitter.com/Ninoerri" alt="Icon made by Ninoeri">@Ninoerri</a>',
        w: 1000,
        h: 1000
      },
      {
        src: '/assets/char/004.jpg',
        thumbnail: '/assets/char/thumb/004.png',
        title: 'Icon made by <a href="https://twitter.com/DarkWhiteComic" alt="Icon made by DarkWhiteComic">@DarkWhiteComic</a>',
        w: 678,
        h: 678
      },
      {
        src: '/assets/char/005.jpg',
        thumbnail: '/assets/char/thumb/005.png',
        title: 'Badge made by <a href="https://twitter.com/Gamejack99" alt="Badge made by Gamejack">@Gamejack99</a>',
        w: 1022,
        h: 1200
      },
      {
        src: '/assets/char/006.jpg',
        thumbnail: '/assets/char/thumb/006.png',
        title: 'Icon made by <a href="https://twitter.com/DharkTemptation" alt="Icon made by Sheltie">@DharkTemptation</a>',
        w: 960,
        h: 1280
      },
      {
        src: '/assets/char/007.jpg',
        thumbnail: '/assets/char/thumb/007.png',
        title: 'EF24 Badge made by <a href="https://twitter.com/BlueHunterART" alt="EF24 Badge made by BlueHunter">@BlueHunterART</a>',
        w: 2247,
        h: 2948
      },
      {
        src: '/assets/char/008.png',
        thumbnail: '/assets/char/thumb/008.png',
        title: 'Icon made by <a href="https://twitter.com/Ninoerri" alt="Icon made by Ninoeri">@Ninoerri</a>',
        w: 1000,
        h: 1000
      },
      {
        src: '/assets/char/009.jpg',
        thumbnail: '/assets/char/thumb/009.png',
        title: 'Inktober sketch made by <a href="https://twitter.com/ThaboMeerkat" alt="Inktober sketch made by Thabo">@ThaboMeerkat</a>',
        w: 1199,
        h: 584
      },
      {
        src: '/assets/char/010.jpg',
        thumbnail: '/assets/char/thumb/010.png',
        title: 'Sketch made by <a href="https://twitter.com/KuraiTora13" alt="Sketch made by KuraiTora13">@KuraiTora13</a>',
        w: 827,
        h: 1200
      },
      {
        src: '/assets/char/011.jpg',
        thumbnail: '/assets/char/thumb/011.png',
        title: 'Sketch made by <a href="https://twitter.com/GrizzlyWolfSam" alt="Sketch made by Sammy Coyote">@GrizzlyWolfSam</a>',
        w: 900,
        h: 1200
      },
      {
        src: '/assets/char/012.png',
        thumbnail: '/assets/char/thumb/012.png',
        title: 'Icon made by <a href="https://twitter.com/Ninoerri" alt="Icon made by Ninoeri">@Ninoerri</a>',
        w: 611,
        h: 1000
      },
      {
        src: '/assets/char/013.png',
        thumbnail: '/assets/char/thumb/013.png',
        title: 'Icon made by <a href="https://twitter.com/Ninoerri" alt="Icon made by Ninoeri">@Ninoerri</a>',
        w: 655,
        h: 1000
      },
      {
        src: '/assets/char/014.png',
        thumbnail: '/assets/char/thumb/014.png',
        title: 'Icon made by <a href="https://twitter.com/Ninoerri" alt="Icon made by Ninoeri">@Ninoerri</a>',
        w: 655,
        h: 1000
      },
      {
        src: '/assets/char/016.png',
        thumbnail: '/assets/char/thumb/016.png',
        title: 'Artwork of <a href="https://twitter.com/skollwuff/" alt="Sköll">Sköll (as Styx)</a>, Stani and me drawn by <a href="https://www.furaffinity.net/user/askha/" alt="Artwork of Sköll, Stani and me by Askha">@askha</a>',
        w: 1000,
        h: 707
      },
      {
        src: '/assets/char/017.png',
        thumbnail: '/assets/char/thumb/017.png',
        title: 'Drawing of me made by <a href="https://t.me/Kiorayla" alt="Drawing by of made by Kiorayla">@Kiorayla</a>',
        w: 1000,
        h: 1000
      },
      {
        src: '/assets/char/018.png',
        thumbnail: '/assets/char/thumb/018.png',
        title: 'Icon of me made by <a href="https://t.me/Azsharakletete" alt="Icon of me made by Azsharakletete">@Azsharakletete</a>',
        w: 500,
        h: 500
      },
      {
        src: '/assets/char/019.png',
        thumbnail: '/assets/char/thumb/019.png',
        title: 'Drawing of me made by <a href="https://twitter.com/BirtyFur" alt="Drawing of me made by Birty">@BirtyFur</a>',
        w: 1000,
        h: 889
      },
      {
        src: '/assets/char/020.png',
        thumbnail: '/assets/char/thumb/020.png',
        title: 'Drawing of Nara and me made by <a href="https://www.furaffinity.net/user/makangeni/" alt="Drawing of Nara and me made by Makangeni">@Makangeni</a>',
        w: 1000,
        h: 560
      },
      {
        src: '/assets/char/021.png',
        thumbnail: '/assets/char/thumb/021.png',
        title: 'Icon of me made by <a href="https://twitter.com/Fellfallow_Art" alt="Icon of me made by Fellfallow">@Fellfallow_Art</a>',
        w: 512,
        h: 512
      },
      {
        src: '/assets/char/022.png',
        thumbnail: '/assets/char/thumb/022.png',
        title: 'Drawing of me made by <a href="https://twitter.com/FlashWhite_" alt="Drawing of me made by FlashWhite">@FlashWhite_</a>',
        w: 512,
        h: 715
      },
      {
        src: '/assets/char/023.png',
        thumbnail: '/assets/char/thumb/023.png',
        title: 'Drawing of me made by <a href="https://twitter.com/OggyOsbourne" alt="Drawing of me made by OggyOsbourne">@OggyOsbourne</a>',
        w: 1024,
        h: 1024
      }],
      options: {
        shareEl: false,
        bgOpacity: 0.8,
        maxSpreadZoom: 1.5,
        closeOnScroll: true,
        closeOnVerticalDrag: true,
        captionEl: true,
        history: true
      }
    }
  },
  components: {
    VuePictureSwipe
  }
}
</script>
<style scoped>
table.paleBlueRows {
  border: 1px solid #FFFFFF;
  text-align: center;
}
table.paleBlueRows td, table.paleBlueRows th {
  border: 1px solid #FFFFFF;
  padding: 4px 4px;
}
table.paleBlueRows tbody td {
  font-size: 13px;
}
table.paleBlueRows tr:nth-child(even) {
  background: #D0E4F5;
}
table.paleBlueRows thead {
  background: #0B6FA4;
  border-bottom: 5px solid #FFFFFF;
}
table.paleBlueRows thead th {
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  border-left: 2px solid #FFFFFF;
}
table.paleBlueRows thead th:first-child {
  border-left: none;
}

table.paleBlueRows tfoot td {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Art.vue